module.exports = __webpack_public_path__ + "img/gift-box.4d918fc6.png";